// Hva som faktisk skjedde med e-posten, sett fra fakturaen.
//
// «Sendt» betyr bare at Resend tok imot e-posten. Om den kom fram, ble avvist
// eller havnet i soppelposten kommer som et webhook-event noen sekunder senere
// (functions/mail/invoiceDeliveryStatus.ts skriver det tilbake paa sendingen).
// Her oversettes det til noe brukeren kan handle paa: kom den fram, eller maa
// adressen fikses og dokumentet sendes paa nytt?
(function initInvoiceDelivery(global) {
  const text = (value) => String(value || '').trim();

  const FAILED = ['bounced', 'failed', 'complained'];

  const LABELS = {
    sent: 'Sendt',
    received: 'Mottatt av e-posttjenesten',
    delivery_delayed: 'Forsinket underveis',
    delivered: 'Levert',
    opened: 'Åpnet av mottakeren',
    clicked: 'Lenken er åpnet',
    external: 'Levert utenfor Plumme',
    complained: 'Merket som søppelpost',
    failed: 'E-posten kunne ikke sendes',
    bounced: 'E-posten kom ikke fram',
  };

  const isFailed = (status) => FAILED.includes(text(status));

  const label = (status) => LABELS[text(status)] || '';

  // Siste sending er den som gjelder: har brukeren sendt paa nytt til en adresse
  // som virker, er ikke den forrige avvisningen lenger et aapent problem.
  const lastSend = (invoice) => {
    const events = Array.isArray(invoice?.sendEvents) ? invoice.sendEvents : [];
    return events.length ? events[events.length - 1] : null;
  };

  const summary = (invoice) => {
    const event = lastSend(invoice);
    const externalAt = text(invoice?.deliveredExternallyAt);
    const eventAt = text(event?.deliveryEventAt) || text(event?.sentAt);
    // A later real email send takes over as the current delivery state. Until
    // then, external delivery also closes an earlier bounce or failure.
    if (externalAt && (!event || !eventAt || Date.parse(externalAt) >= Date.parse(eventAt))) {
      return { status: 'external', label: label('external'), message: '', to: '', at: externalAt, failed: false };
    }
    if (!event) return { status: '', label: '', message: '', to: '', at: '', failed: false };
    const status = text(event.deliveryStatus);
    return {
      status,
      label: label(status),
      message: text(event.deliveryMessage),
      to: text(event.to),
      at: eventAt,
      failed: isFailed(status),
    };
  };

  // Adressekontroll for sendedialogen. Bevisst romslig paa form, men streng paa
  // tegnsett: e-posttjenesten tar bare imot ASCII, saa `kunde@bedriftø.no` blir
  // avvist naar sendingen allerede er i gang. Da er det bedre aa si det med en
  // gang, med en tekst som forklarer hva som er galt.
  const ASCII_EMAIL = /^[!-~]+@[!-~]+$/;
  const emailProblem = (value) => {
    const address = text(value);
    if (!address) return 'missing';
    if (!/^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(address)) return 'format';
    if (!ASCII_EMAIL.test(address)) return 'charset';
    return '';
  };

  const looksLikeEmail = (value) => emailProblem(value) === '';

  global.PlummeInvoiceDelivery = { isFailed, label, lastSend, summary, looksLikeEmail, emailProblem };
})(typeof window !== 'undefined' ? window : globalThis);
